import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const InstitutionInfoStep = ({ formData, errors, onChange }) => {
  const institutionTypeOptions = [
    { value: 'public-school', label: 'École Publique' },
    { value: 'private-school', label: 'École Privée' },
    { value: 'university', label: 'Université' },
    { value: 'vocational', label: 'Centre de Formation Professionnelle' },
    { value: 'ministry', label: 'Ministère de l\'Education' },
    { value: 'ngo', label: 'ONG / Organisation' },
    { value: 'independent', label: 'Conseiller Indépendant' }
  ];

  const positionOptions = [
    { value: 'head-counselor', label: 'Conseiller Principal' },
    { value: 'counselor', label: 'Conseiller d\'Orientation' },
    { value: 'assistant-counselor', label: 'Conseiller Assistant' },
    { value: 'coordinator', label: 'Coordinateur d\'Orientation' },
    { value: 'director', label: 'Directeur des Services d\'Orientation' }
  ];

  const capacityOptions = [
    { value: '1-50', label: '1-50 étudiants' },
    { value: '51-100', label: '51-100 étudiants' },
    { value: '101-200', label: '101-200 étudiants' },
    { value: '201-500', label: '201-500 étudiants' },
    { value: '500+', label: '500+ étudiants' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-purple-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">3</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Informations Institutionnelles
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Renseignez votre affiliation institutionnelle et votre charge de travail.
            </p>
          </div>
        </div>
      </div>

      <Input
        label="Nom de l'Institution"
        type="text"
        name="institutionName"
        placeholder="Ex: Lycée Blaise Diagne, Université Cheikh Anta Diop"
        value={formData?.institutionName}
        onChange={onChange}
        error={errors?.institutionName}
        required
      />

      <Select
        label="Type d'Institution"
        options={institutionTypeOptions}
        value={formData?.institutionType}
        onChange={(value) => onChange({ target: { name: 'institutionType', value } })}
        placeholder="Sélectionnez le type"
        error={errors?.institutionType}
        required
      />

      <Select
        label="Poste Occupé"
        options={positionOptions}
        value={formData?.position}
        onChange={(value) => onChange({ target: { name: 'position', value } })}
        placeholder="Sélectionnez votre poste"
        error={errors?.position}
        required
      />

      <Select
        label="Capacité de Charge d'Étudiants"
        options={capacityOptions}
        value={formData?.studentCapacity}
        onChange={(value) => onChange({ target: { name: 'studentCapacity', value } })}
        placeholder="Nombre d'étudiants que vous gérez"
        description="Cela nous aide à adapter les outils de gestion à votre charge de travail"
        error={errors?.studentCapacity}
      />

      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-blue-900 mb-1">Vérification Professionnelle</h4>
            <p className="text-sm text-blue-800">
              Votre compte sera soumis à une vérification pour garantir l'intégrité de notre plateforme. Vous recevrez une confirmation par email dans les 48 heures.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstitutionInfoStep;